import { useReduxState } from 'hooks';

interface Props {
  title: string;
}

const BoxSectionTitle = ({ title }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="title">
      {title}

      <style jsx>{`
        .title {
          background-color: ${theme.lightGreyLighter};
          color: ${theme.textColorLight};
          font-size: 1.4rem;
          font-weight: 700;
          padding: 10px 20px;
        }
        .title:not(:first-child) {
          border-top: 1px solid ${theme.lightGreyDark};
        }
      `}</style>
    </div>
  );
};

export default BoxSectionTitle;
